import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9bcbb3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-password" }
const _hoisted_2 = { class: "new-password__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "new-password__title" }, [
  /*#__PURE__*/_createTextVNode(" Введите новый "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" пароль ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "new-password__text new-password__text_margin"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Придумайте новый пароль, чтобы данные ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" о ваших пациентах были защищены. ")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "new-password__text"
}
const _hoisted_10 = { class: "new-password__footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Войти ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Войти в кабинет ")

import { reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { FormInstance, FormRules } from 'element-plus'
import { passwordApi } from '@/shared/api'
import { FormPasswordType } from '@/shared/types'
import { showErrorMessage, validateMatchPasswords } from '@/shared/utils'
import { COMMON_RULES } from '@/shared/constants'
import WHeaderAuth from '@/widgets/WHeaderAuth/WHeaderAuth.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  isFirstEntrance: Boolean,
},
  setup(__props) {



const router = useRouter()
const route = useRoute()

const isPasswordRecovered = ref(false)
const newPasswordForm = ref<FormInstance>()

const newPasswordFormData: FormPasswordType = reactive({
  password: '',
  repeatPassword: '',
})

const newPasswordValidationRules = reactive<FormRules>({
  password: [
    COMMON_RULES.passwordRequired,
    COMMON_RULES.passwordTooShort,
    COMMON_RULES.passwordTooLong,
    COMMON_RULES.passwordHasNotLetter,
    COMMON_RULES.passwordHasSpace,
    COMMON_RULES.passwordTooEasy,
  ],
  repeatPassword: [
    COMMON_RULES.repeatPassword,
    COMMON_RULES.passwordTooShort,
    COMMON_RULES.passwordTooLong,
    COMMON_RULES.passwordHasNotLetter,
    COMMON_RULES.passwordHasSpace,
    COMMON_RULES.passwordTooEasy,
    {
      validator: (_, value, callback) =>
        validateMatchPasswords(newPasswordFormData.password, value, callback),
      trigger: 'blur',
    },
  ],
})

const changePassword = async (token: string): Promise<void> => {
  const [error] = await passwordApi.changePassword(
    newPasswordFormData.password,
    token
  )

  if (error) {
    showErrorMessage(error)
  } else {
    isPasswordRecovered.value = true
  }
}

const changePasswordOnFirstLogin = async (): Promise<void> => {
  const [error] = await passwordApi.changePasswordOnFirstLogin(
    newPasswordFormData.password,
    newPasswordFormData.repeatPassword
  )

  if (error) {
    showErrorMessage(error)
  } else {
    isPasswordRecovered.value = true
  }
}

const handleSubmitForm = (form: FormInstance | undefined): void => {
  if (!form) return

  form.validate(async (valid): Promise<void> => {
    if (valid) {
      const token = route.query.token as string

      if (token) {
        await changePassword(token)
      } else {
        await changePasswordOnFirstLogin()
      }
    }
  })
}

const handleReturnToAuth = (): void => {
  router.push({ name: 'AuthPage' })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WHeaderAuth, { class: "layout__header" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (__props.isFirstEntrance)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref_key: "newPasswordForm",
        ref: newPasswordForm,
        model: _unref(newPasswordFormData),
        rules: _unref(newPasswordValidationRules),
        class: "new-password__form"
      }, {
        default: _withCtx(() => [
          (!isPasswordRecovered.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, { prop: "password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(newPasswordFormData).password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(newPasswordFormData).password) = $event)),
                      placeholder: "Новый пароль",
                      class: "el-input--authorization"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "repeatPassword" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(newPasswordFormData).repeatPassword,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(newPasswordFormData).repeatPassword) = $event)),
                      placeholder: "Повтор пароля",
                      class: "el-input--authorization"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_9, "Пароль обновлен"))
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", _hoisted_10, [
        (!isPasswordRecovered.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "el-button--authorization",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSubmitForm(newPasswordForm.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "el-button--authorization",
              onClick: handleReturnToAuth
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}
}

})